import React from "react"
import classnames from "classnames"

import styles from "./styles.css"

const ScheduleSkeleton = () => {
  const mainSectionClasses = classnames(
    styles.mainSectionSkeleton,
    styles.whiteBackgroundSkeleton
  )

  return (
    <div className={mainSectionClasses}>
      <table className={styles.table}>
        <thead className={styles.tableHeader}>
          <tr>
            <th className={styles.skeleton}></th>
          </tr>
        </thead>
        <tbody className={styles.tableBody}>
          <tr>
            <td className={styles.skeleton}></td>
          </tr>
          <tr>
            <td className={styles.skeleton}></td>
          </tr>
          <tr>
            <td className={styles.skeleton}></td>
          </tr>
          <tr>
            <td className={styles.skeleton}></td>
          </tr>
          <tr>
            <td className={styles.skeleton}></td>
          </tr>
          <tr>
            <td className={styles.skeleton}></td>
          </tr>
          <tr>
            <td className={styles.skeleton}></td>
          </tr>
          <tr>
            <td className={styles.skeleton}></td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default ScheduleSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/ScheduleSkeleton/index.js